import UtilObject from '../utils/UtilObject';

const intState = {
  lang: 'en',
  currentUser: UtilObject.EMPTY_OBJECT,
  accessToken: '',
  deviceKey: '',
  selectedTheme: 'light',
  orderPageFilters: UtilObject.EMPTY_OBJECT,
  paymentPageFilters: UtilObject.EMPTY_OBJECT,
  visitPageFilters: UtilObject.EMPTY_OBJECT,
  userPageFilters: UtilObject.EMPTY_OBJECT,
  devicePageFilters: UtilObject.EMPTY_OBJECT,
  branchPageFilters: UtilObject.EMPTY_OBJECT,
  debitPageFilters: UtilObject.EMPTY_OBJECT,
  productPageFilters: UtilObject.EMPTY_OBJECT,
  userQuantitiesFilters: UtilObject.EMPTY_OBJECT,
  productQuantitiesFilters: UtilObject.EMPTY_OBJECT,
  productListState: UtilObject.EMPTY_OBJECT,
  inventoryQuantityFilters: UtilObject.EMPTY_OBJECT,
  customerStatementFilters: UtilObject.EMPTY_OBJECT,
  analyticsFilters: UtilObject.EMPTY_OBJECT,
  managerAnalyticsFilters: UtilObject.EMPTY_OBJECT,
  customerPageFilters: UtilObject.EMPTY_OBJECT,
  policyPageFilters: UtilObject.EMPTY_OBJECT,
  badgeCountOrder: 0,
  badgeCountPayment: 0,
  badgeCountCustomer: 0,
};

const AuthReducer = (state = intState, action) => {
  switch (action.type) {
    case 'SET_LANG':
      return { ...state, lang: action.payload };
    case 'SET_DEVICEKEY':
      return { ...state, deviceKey: action.payload };
    case 'SET_CURRENT_USER':
      return { ...state, currentUser: action.payload };
    case 'SET_ACCESS_TOKEN':
      return { ...state, accessToken: action.payload };
    case 'SET_SELECTED_THEME':
      return { ...state, selectedTheme: action.payload };
    case 'SET_ORDER_PAGE_FILTERS':
      return { ...state, orderPageFilters: action.payload };
    case 'SET_PAYMENT_PAGE_FILTERS':
      return { ...state, paymentPageFilters: action.payload };
    case 'SET_VISIT_PAGE_FILTERS':
      return { ...state, visitPageFilters: action.payload };
    case 'SET_USER_PAGE_FILTERS':
      return { ...state, userPageFilters: action.payload };
    case 'SET_DEVICE_PAGE_FILTERS':
      return { ...state, devicePageFilters: action.payload };
    case 'SET_BRANCH_PAGE_FILTERS':
      return { ...state, branchPageFilters: action.payload };
    case 'SET_DEBIT_PAGE_FILTERS':
      return { ...state, debitPageFilters: action.payload };
    case 'SET_PRODUCT_PAGE_FILTERS':
      return { ...state, productPageFilters: action.payload };
    case 'SET_USER_QUANTITIES_FILTERS':
      return { ...state, userQuantitiesFilters: action.payload };
    case 'SET_PRODUCT_QUANTITIES_FILTERS':
      return { ...state, productQuantitiesFilters: action.payload };
    case 'SET_PRODUCT_LIST_STATE':
      return { ...state, productListState: action.payload };
    case 'SET_INVENTORY_QUANTITY_FILTERS':
      return { ...state, inventoryQuantityFilters: action.payload };
    case 'SET_CUSTOMER_STATEMENT_FILTERS':
      return { ...state, customerStatementFilters: action.payload };
    case 'SET_ANALYTICS_FILTERS':
      return { ...state, analyticsFilters: action.payload };
    case 'SET_MANAGER_ANALYTICS_FILTERS':
      return { ...state, managerAnalyticsFilters: action.payload };
    case 'SET_CUSTOMER_PAGE_FILTERS':
      return { ...state, customerPageFilters: action.payload };
    case 'SET_POLICY_PAGE_FILTERS':
      return { ...state, policyPageFilters: action.payload };
    case 'SET_BADGE_COUNT_ORDER':
      return { ...state, badgeCountOrder: action.payload };
    case 'SET_BADGE_COUNT_PAYMENT':
      return { ...state, badgeCountPayment: action.payload };
    case 'SET_BADGE_COUNT_CUSTOMER':
      return { ...state, badgeCountCustomer: action.payload };
    default:
      return state;
  }
};

export default AuthReducer;
